import Loader from 'components/molecules/Loader';
import React, { useEffect, useRef, useState } from 'react';
import { ppaId } from './PPA';
import { useFillHeightToFitScreen } from 'hooks/general/useFillHeightToFitScreen';

const ExecutiveSummary = () => {
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);
    const [showIframe, setShowIframe] = useState(false);

    const tableHeight = useRef<number | null>(0);

    //this hook with give height to fill the screen height
    tableHeight.current = useFillHeightToFitScreen({
        id: ppaId,
        height: tableHeight.current,
        buffer: 60, //footer,
        triggerDummyRender: true,
    });

    useEffect(() => {
        // Show iframe after 1 second, but keep loader until iframe loads
        const timer = setTimeout(() => {
            setShowIframe(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const handleIframeLoad = () => {
        setIsIframeLoaded(true);
    };

    const handleIframeError = () => {
        console.error('Failed to load iframe');
        setIsIframeLoaded(true); // Hide loader even on error
    };

    return (
        <div
            id={ppaId}
            className="w-full border-0 bg-white relative"
            style={{
                height: tableHeight.current || 'calc(100vh - var(--navbar-height))',
                margin: 0,
                padding: 0,
            }}
        >
            {/* Show loader until iframe is loaded */}
            {!isIframeLoaded && (
                <div className="absolute inset-0 z-10 bg-white">
                    <Loader style={{ height: '100%' }} />
                </div>
            )}

            {/* Show iframe after 1 second */}
            {showIframe && (
                <iframe
                    className="w-full border-0"
                    style={{
                        height: tableHeight.current || 'calc(100vh - var(--navbar-height))',
                        margin: 0,
                        padding: 0,
                    }}
                    src="https://jkhjkhj43434uiyuikjhakfdjshdkfjshrgm-navigato.lovable.app/executive-summary"
                    title="Executive Summary"
                    onLoad={handleIframeLoad}
                    onError={handleIframeError}
                />
            )}
        </div>
    );
};

export default ExecutiveSummary;
